import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next'

// import Loader from '~components/Loader/Loader';
import Loader from '../Loader/Loader';
import PaymentSetup from './PaymentSetup';
import PaymentMethodsItem from './PaymentMethodsItem';

import { useHookStore } from '../../hook-store/store';
import { 
  cardExpire,
  // updateSubscriptionDefaultPaymentMethod,
  // detachPaymentMethod,
 } from '../../utils/stripe/payment-method-utils';
// import { 
//   getCustomerSubscriptions,
// } from '../../utils/stripe/usage-based-billing-utils';



import classes from './PaymentMethods.module.css';

function PaymentMethods(props) {

  const [t] = useTranslation('translation');

  const [store, dispatch] = useHookStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
    customerMethods,
    usageBasedValidMethod,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);
  const [modifiedMethods, setModifiedMethods] = useState([]);
  const [showPaymentSetup, setShowPaymentSetup] = useState(false);
  // const [selectedId, setSelectedId] = useState('');
  // const [showConfirmDetach, setShowConfirmDetach] = useState(false);
  
  useEffect(() => {
    if (customerMethods.length > 0) {
      createModifiedMethodsHandler(customerMethods);
    }
  },[customerMethods]);

  useEffect(() => {
    if (customerMethods.length > 0 && usageBasedSubscription) {
      const methodList = [];

      for (const method of customerMethods) {
        const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
        
        if (!cardExpired) {
          methodList.push(method);
        }
      }
  
      console.log(methodList);
      // if (methodList.length === 1) {
      //   dispatch('SET_VALID_DEFAULTMETHOD', methodList[0]);
      // }
  
      if (methodList.length > 0) {
        const subscriptionMethod = methodList.find(method => {
          return method.id === usageBasedSubscription.default_payment_method;
        });

        if (subscriptionMethod) {
          dispatch('SET_USAGEBASEDVALIDMETHOD', subscriptionMethod);
        } else {
          dispatch('SET_USAGEBASEDVALIDMETHOD', null);
        }
      }
      else {
        dispatch('SET_USAGEBASEDVALIDMETHOD', null);
      }
    }
  },[customerMethods, usageBasedSubscription]);


  const createModifiedMethodsHandler = (customerMethods) => {
    
    let noSubscriptionMethods = customerMethods;

    const subscriptionMethod = customerMethods.find(method => {
      return method.id === usageBasedSubscription.default_payment_method;
    });

    if (subscriptionMethod) {
      noSubscriptionMethods = customerMethods.filter(method => {
        return method.id !== subscriptionMethod.id;
      });
    }

    const notExpiredMethods = noSubscriptionMethods.filter(method => {
      return !cardExpire(method.card.exp_month, method.card.exp_year);
    });

    const expiredMethods = noSubscriptionMethods.filter(method => {
      return cardExpire(method.card.exp_month, method.card.exp_year);
    });

    let combined = [];

    if (subscriptionMethod) {
      combined = [subscriptionMethod].concat(notExpiredMethods.concat(expiredMethods));
    } else {
      combined = notExpiredMethods.concat(expiredMethods);
    }

    const usageBasedList = combined.filter(method => {
      return method.metadata && method.metadata.imagePhotoUsageBased;
    });
    
    // console.log('notExpiredMethods', notExpiredMethods)
    setModifiedMethods(usageBasedList);
  };

  // const updateSubscriptionMethodHandler = async (subscriptionId, paymentMethodId) => {
  //   try {
  //     setIsLoading(true);
  //     // setError('');

  //     const resData = await updateSubscriptionDefaultPaymentMethod(
  //       BACKEND_URL, 
  //       localStorage.getItem('token'),
  //       localStorage.getItem('customerId'),
  //       subscriptionId,
  //       paymentMethodId,
  //     );

  //     // console.log(resData);

  //     if (resData.data 
  //       // && resData.data.default_payment_method === paymentMethodId
  //     ) {
        
  //       dispatch('SET_USAGEBASEDSUBSCRIPTION', resData.data);
  //     }

  //     setIsLoading(false);

  //   } catch(err) {
  //     console.log(err);
  //     setIsLoading(false);
  //   }
  // };


  // const detachMethodHandler = async (paymentMethodId) => {
  //   try {
  //     setIsLoading(true);
  //     // setError('');

  //     const resData = await detachPaymentMethod(
  //       BACKEND_URL, 
  //       localStorage.getItem('token'),
  //       localStorage.getItem('customerId'),
  //       paymentMethodId,
  //     );

  //     // console.log(resData);

  //     if (resData.data) {
  //       const deletedList = customerMethods.filter(method => {
  //         return method.id !== paymentMethodId;
  //       });

  //       dispatch('SET_CUSTOMERMETHODS', deletedList);

  //       if (usageBasedSubscription && 
  //           usageBasedSubscription.default_payment_method === paymentMethodId
  //       ) {
  //           getUsageBasedSubscription();
  //         }
  //     }

  //     setIsLoading(false);

  //   } catch(err) {
  //     console.log(err);
  //     setIsLoading(false);
  //   }
  // };

  // const getUsageBasedSubscription = async () => {
  //   try {
  //     const customerId = localStorage.getItem('customerId');

  //     const resData = await getCustomerSubscriptions(
  //       BACKEND_URL,
  //       localStorage.getItem('token'),
  //       customerId,
  //     )
      
  //     // console.log('usage based subscription', result, resData);
      
  //     if (resData?.data) {
  //       const usageBasedSubscription = resData.data.find(ele => {
  //         return ele.plan.id === usageBasedPrice.id
  //       });
  //       // console.log('usage based subscription', usageBasedSubscription);
  //       if (usageBasedSubscription) {
  //         dispatch('SET_USAGEBASEDSUBSCRIPTION', usageBasedSubscription);
  //       }

  //     }

  //     return resData;

  //   } catch(err) {
  //     console.log(err);
  //     throw err;
  //   }
  // };




  let paymentMethodsBody = (
    <div>
      {t('usageBased06', 'No payment method, please add new one')}
    </div>
  );


  if (modifiedMethods.length >= 0) {
    paymentMethodsBody = (
      <div>
        <div className={classes.paymentMethodsRow}>
          <span className={classes.paymentMethodsTitle}>
            {t('usageBased07', 'Payment methods')}
          </span>
        </div>
        {!usageBasedValidMethod && (
          <div className={classes.paymentMethodsRow}>
            {t('usageBased08', 'Valid payment method not found.')}
            {t('usageBased09', 'Please add card information or select from already added payment methods.')}
          </div>
        )}
        <div>
          {isLoading && (
            <Loader />
          )}
        </div>
        <ul className={classes.paymentMethodsRow}>
          {modifiedMethods.map(method => {
            const cardInfo = method.card;
            const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
            
            const isSubscriptionMethod = method.id === usageBasedSubscription.default_payment_method;

            return (
              <li key={method.id}>
                <PaymentMethodsItem
                  method={method}
                  cardInfo={cardInfo}
                  isSubscriptionMethod={isSubscriptionMethod}
                  cardExpired={cardExpired}
                />
              </li>
            );
          })}
        </ul>
        <div>
          <div className={classes.paymentMethodsRow}>
            <button className='btnBase'
              disabled={isLoading}
              onClick={() => {
                setShowPaymentSetup(true);
              }}
            >
              {t('usageBased10', 'Add new card')}
            </button>
          </div>
          {showPaymentSetup && (
            <div className={classes.paymentMethodsRow}>
              <PaymentSetup 
                setShowPaymentSetup={setShowPaymentSetup}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
 

  return (
    <Fragment>
      <div>
        {paymentMethodsBody}
      </div>
    </Fragment>
  );
}

export default PaymentMethods;
